export default __webpack_public_path__ + "static/dibk.uebersicht-4a13abc08babd500421eab1e50e09d25.jpg";